<template>
	<a
		class="site_button_secondary"
		:class="[theme, type]"
		:href="parsedLink ? parsedLink.url : null"
		:target="parsedLink.target ? parsedLink.target : (target ? target : (type === 'resource' ? '_blank' : null))"
		@mouseenter="hovered = true"
		@mouseleave="hovered = false"
		ref="site_button_secondary"
		:download="type === 'file'"
	>
		<video-icon
			class="video_icon"
			v-if="type === 'video'"
		></video-icon>

		<span v-html="button_label ? button_label : parsedLink.title"></span>

		<resource-link
			v-if="type === 'file'"
			class='resource'
		></resource-link>

		<external-link
			class="external_link_icon"
			v-if="
        parsedLink.target === '_blank' ||
        button_link.target === '_blank' ||
        target === '_blank'
      "
		></external-link>

	</a>
</template>

<script>
import ExternalLink from './ExternalLink.vue';
import ResourceLink from './ResourceLink.vue';
import VideoIcon from './VideoIcon.vue';
export default {
	data() {
		return {
			button_label: this.label,
			button_link: this.link,
			hovered: false,
		};
	},

	props: {
		link: {},
		label: {},
		target: {},
		theme: {},
		type: {
			default: 'normal',
		},
	},

	computed: {
		parsedLink() {
			if (typeof this.link === 'object' && this.link !== null) {
				return this.link;
			} else if (!Array.isArray(this.link)) {
				try {
					return JSON.parse(this.link);
				} catch (e) {
					return null;
				}
			} else {
				return null;
			}
		},
	},

	watch: {
		link() {
			this.button_link = this.link;
		},
	},

	methods: {
		checkEmpty(e) {
			if (this.button_link.url === '#') {
				// this.$refs.site_button_secondary.removeAttribute('href');
				e.preventDefault();
			}
		},
	},

	components: { ExternalLink, VideoIcon, ResourceLink },

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.site_button_secondary {
	display: inline-flex;
	padding: 0 16px;
	border: 1px solid var(--midnight);
	border-radius: 30px;
	background: transparent;
	text-decoration: none;
	height: 32px;
	display: inline-flex;
	justify-content: center;
	align-items: center;
	transition: 0.2s ease all;
	color: var(--midnight);
	background: transparent;

	@media (hover) {
		&:hover {
			background: var(--midnight);
			transition: 0.2s ease all;
			cursor: pointer;
			color: var(--white);

			span {
				color: var(--white);
			}

			svg {
				display: flex;

				&::v-deep {
					path {
						stroke: var(--cobalt);
					}
				}

				&.resource {
					&::v-deep {
						path {
							fill: var(--cobalt);

							.theme--emerald & {
								stroke: var(--cobalt);
							}

							.theme--blue &,
							.theme--dark_blue & {
								fill: var(--midnight) !important;
							}

							.theme--rose & {
								stroke: var(--cobalt);
							}
						}
					}
				}

				&.external_link_icon {
					&::v-deep {
						path {
							stroke: var(--cobalt);

							.theme--emerald & {
								stroke: var(--cobalt);
							}

							.theme--blue &,
							.theme--dark_blue & {
								stroke: var(--midnight) !important;
							}

							.theme--rose & {
								stroke: var(--cobalt);
							}
						}
					}
				}
			}
		}
	}

	&:disabled {
		opacity: 0.5;
	}

	span {
		font: normal normal 600 15px/18px var(--primary-font-family);
		color: var(--midnight);
		margin-right: 0;
		position: relative;
		z-index: 10;
		margin-top: 2px;
	}

	svg {
		display: flex;

		&::v-deep {
			path {
				stroke: var(--cobalt);

				.theme--rose &,
				.theme--emerald & {
					stroke: var(--midnight);
				}
			}
		}
	}

	&.reverse {
		background: transparent;
		border: 1px solid var(--white);
		color: var(--white);

		span {
			color: var(--white);
		}

		svg {
			display: flex;

			&::v-deep {
				path {
					stroke: var(--white);
				}
			}
		}

		@media (hover) {
			&:hover {
				background: var(--white);
				transition: 0.2s ease all;
				cursor: pointer;
				color: var(--midnight);

				span {
					color: var(--midnight);
				}

				svg {
					display: flex;

					&::v-deep {
						path {
							stroke: var(--cobalt);
						}
					}

					&.resource {
						&::v-deep {
							path {
								fill: var(--cobalt);
							}
						}
					}
				}
			}
		}
	}

	&.mob-menu {
		background: transparent;
		border: unset;
		color: var(--cobalt);

		@media (min-width: $tablet) {
			padding: 0;
		}

		span {
			color: var(--cobalt);
		}

		@media (hover) {
			&:hover {
				background: transparent;
				transition: 0.2s ease all;
				cursor: pointer;
				color: var(--cobalt);
				text-decoration: underline;

				span {
					color: var(--cobalt);
				}
			}
		}
	}

	&.filter {
		background: transparent;
		transition: 0.2s ease all;
		cursor: pointer;
		color: var(--cobalt);
		border: 1px solid var(--cobalt);

		span {
			color: var(--cobalt);
			font-weight: 400;
		}

		svg {
			display: flex;

			&::v-deep {
				path {
					stroke: var(--cobalt);
				}
			}
		}

		@media (hover) {
			&:hover {
				background: var(--midnight);
				border: 1px solid var(--cobalt);
				transition: 0.2s ease all;
				cursor: pointer;
				color: var(--white);

				span {
					color: var(--white);
				}

				svg {
					display: flex;

					&::v-deep {
						path {
							stroke: var(--white);
						}
					}
				}
			}
		}
	}

	&.current {
		background: var(--cobalt);
		transition: 0.2s ease all;
		cursor: pointer;
		color: var(--white);

		span {
			color: var(--white);
		}

		svg {
			display: flex;

			&::v-deep {
				path {
					stroke: var(--white);
				}
			}
		}
	}

	.video_icon {
		margin-right: 7px;
	}

	.external_link_icon {
		margin-left: 8px;

		&::v-deep {
			line,
			path {
				fill: var(--cobalt);
				transition: 0.2s ease all;

				.theme--rose &,
				.theme--emerald & {
					fill: var(--midnight);
				}

				g {
					fill: var(--cobalt);
					transition: 0.2s ease all;

					.theme--rose &,
					.theme--emerald & {
						fill: var(--midnight);
					}
				}
			}
		}

		/* .theme--blue & {
			line,
			path {
				stroke: var(--cobalt);
				transition: 0.2s ease all;

				g {
					stroke: var(--cobalt);
					transition: 0.2s ease all;
				}
			}
		} */
	}

	.resource {
		margin-left: 8px;
		width: 16px;
		height: 16px;

		&::v-deep {
			line,
			path {
				fill: var(--cobalt);
				transition: 0.2s ease all;

				.theme--rose &,
				.theme--emerald & {
					fill: var(--midnight);
				}

				g {
					fill: var(--cobalt);
					transition: 0.2s ease all;

					.theme--rose &,
					.theme--emerald & {
						fill: var(--midnight);
					}
				}
			}
		}
	}

	.theme--dark_blue &,
	.theme--blue & {
		border: 1px solid var(--white);
		color: var(--white);

		span {
			color: var(--white);
		}

		svg {
			&::v-deep {
				path {
					stroke: var(--white);
				}
			}
		}

		&:hover {
			background: var(--white);
			border: 1px solid var(--white);

			span {
				color: var(--midnight);
			}

			svg {
				&::v-deep {
					path {
						stroke: var(--midnight);
					}
				}
			}
		}
	}
}
</style>
